import { render } from "./TV.vue?vue&type=template&id=70844ff5&scoped=true"
import script from "./TV.vue?vue&type=script&lang=js"
export * from "./TV.vue?vue&type=script&lang=js"

import "./TV.vue?vue&type=style&index=0&id=70844ff5&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70844ff5"]])

export default __exports__